<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title> Point Light </ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'radius'" [label]="'Radius'" [min]="0.1" [max]="100" [numberModifier]="'arrows'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'on'" [label]="'On'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'name'" [label]="'Name'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'intensity'" [label]="'Intensity'" [min]="0" [max]="200" [numberModifier]="'slider'"></cm-value-slot>
        <div class="cm-light-settings">
            <cm-value-slot [node]="$node()" [key]="'color'" [label]="'Color'"></cm-value-slot>
        </div>
        <cm-value-slot [node]="$node()" [key]="'lightType'" [label]="'Type'" [selectionPossibilities]="$lightTypePossibilites()"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'visibleDirectly'" [label]="'Visible to Camera'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'visibleInReflections'" [label]="'Visible in Reflections'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'visibleInRefractions'" [label]="'Visible in Refractions'"></cm-value-slot>
    </ng-container>
</cm-inspector-section>
